import React, { useMemo, useState } from "react";
import fileDownload from "js-file-download";
import { Loading } from "components/common";
import {
  GET_BATCHES,
  GET_ANALYTICS_DOWNLOAD,
  GET_BATCH_DOWNLOAD,
} from "utils/mutations";
import { useLazyQuery, useQuery } from "@apollo/react-hooks";
import MarketingAnalytics from "../utils/components/MarketingAnalytics";
import MarketingContainer from "../utils/components/MarketingContainer";

const moment = require("moment");

const computeColumns = () => [
  {
    Header: "Name",
    accessor: (data) => (
      <div className="flex-1">
        <div className="">
          <div className="">{data.batchName}</div>
          <div className="flex mt-2">
            {["delivered", "open", "click"].map((type) => (
              <div className="flex pr-4" style={{ width: 150 }}>
                <p className="pr-1 font-semibold">{`${type}:`}</p>
                <p>
                  {Number.isInteger(data.types && data.types[type])
                    ? data.types[type]
                    : "-"}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    ),
  },
  {
    Header: "Date",
    style: { verticalAlign: "top" },
    accessor: (data) =>
      moment(data.metadata && data.metadata.LastModified)
        .format("MM-DD-YYYY")
        .toLocaleString(),
  },
  {
    Header: "Download",
    unsortable: true,
    className: "flex",
    accessor: (data) => (
      <>
        <button
          type="button"
          className="flex mr-1 h-full py-1 pr-2"
          onClick={() => {
            console.log("pressing...", data);
            data.downloadReport();
          }}
        >
          <i className="fas fa-file-download" />
        </button>
        <button
          type="button"
          className="flex mr-1 h-full py-1 pr-2"
          onClick={() => {
            console.log("pressing...", data);
            data.downloadAnalytics();
          }}
        >
          <i className="fas fa-chart-line" />
        </button>
      </>
    ),
  },
];

const EmailAnalytics = () => {
  const columns = useMemo(() => computeColumns(), []);
  const [filteredBatches, setFilteredBatches] = useState([]);

  const { loading, data } = useQuery(GET_BATCHES, {
    variables: { type: "email" },
    onCompleted: (res) => {
      const parsedBatches = JSON.parse(res && res.getBatches);
      if (parsedBatches && parsedBatches.length) {
        setFilteredBatches(
          parsedBatches.map((batch) => ({
            ...batch,
            downloadReport: () => {
              console.log("should be downloading report...");
              getBatchDownload({
                variables: {
                  batchName: batch.batchName,
                  type: "email",
                },
              });
            },
            downloadAnalytics: () => {
              getAnalyticsDownload({
                variables: {
                  batchName: batch.batchName,
                  type: "email",
                },
              });
            },
          })),
        );
      }
    },
    onError: (err) => {
      console.log(`error getting email batches", ${err}`);
    },
  });

  console.log(data);
  const [getBatchDownload, { loading: loadingReport }] = useLazyQuery(
    GET_BATCH_DOWNLOAD,
    {
      fetchPolicy: "network-only",
      onCompleted: async (res) => {
        const {
          batchDownload: { batchName, csv },
        } = res;
        fileDownload(csv, `${batchName}-${Date.now()}.csv`);
      },
      onError: (err) => {
        console.log("err getting sms batches", err);
      },
    },
  );

  const [getAnalyticsDownload, { loading: loadingAnalytics }] = useLazyQuery(
    GET_ANALYTICS_DOWNLOAD,
    {
      fetchPolicy: "network-only",
      onCompleted: (res) => {
        const analyticsData = res.analyticsDownload;
        const changedBatch = filteredBatches.find(
          (batch) => batch.batchName === analyticsData.batchName,
        );
        changedBatch.types = analyticsData;
        setFilteredBatches([...filteredBatches]);
      },
    },
  );

  return (
    <>
      {loading || loadingReport || loadingAnalytics ? (
        <Loading />
      ) : (
        <MarketingContainer>
          <MarketingAnalytics
            id="sms-batches"
            data={filteredBatches}
            columns={columns}
            title="Email Batches"
          />
        </MarketingContainer>
      )}
    </>
  );
};

export default EmailAnalytics;
